import MapsHomeWorkRoundedIcon from "@mui/icons-material/MapsHomeWorkRounded";

export const map = (props) => {
  return <MapsHomeWorkRoundedIcon {...props} />;
};
